module.exports = __webpack_public_path__ + "d96f5367d2d37da25f11c4511db13831.MP3";